import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import Navbar from '../../../components/comm/Navbar';
import Head from '../../../components/comm/Head';
import DietReport from '../../../components/report/DietReport';
import ExerciseReport from '../../../components/report/ExerciseReport';
import style from './ReportMain.module.css';

const TABS = [
    { key: 'diet', label: '식단 리포트' },
    { key: 'exercise', label: '운동 리포트' },
];

const ReportMain = () => {
    const [activeTab, setActiveTab] = useState('diet');
    const tabBarRef = useRef(null);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const updateIndicator = (key) => {
        const bar = tabBarRef.current;
        if (!bar) return;
        const btn = bar.querySelector(`[data-tab="${key}"]`);
        if (!btn) return;
        const barRect = bar.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        setIndicatorStyle({
            left: btnRect.left - barRect.left,   // 부모 기준 상대 위치
            width: btnRect.width,
        });
    };

    useEffect(() => { updateIndicator(activeTab); }, [activeTab]);

    useEffect(() => {
        const bar = tabBarRef.current;
        if (!bar) return;
        const ro = new ResizeObserver(() => updateIndicator(activeTab));
        ro.observe(bar);
        return () => ro.disconnect();
    }, [activeTab]);

    return (
        <>
          <Head/>
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="0">
                    <div className={style.tabBar} ref={tabBarRef}>
                        {TABS.map(tab => (
                            <button
                                key={tab.key}
                                data-tab={tab.key}
                                className={`${style.subTabBtn} ${activeTab === tab.key ? style.active : ''}`}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.label}
                            </button>
                        ))}
                        <span className={style.subTabSlider} style={indicatorStyle} />
                    </div>

                    {activeTab === 'diet' ? <DietReport /> : <ExerciseReport />}
                </div>
            </div>
            <Navbar />
        </>
    );
};

export default ReportMain;